import { AntPopover, Icons } from '@agro-club/agroclub-shared'
import { refetchFunc } from 'modules/domain/common/hooks'
import { FarmerLoad, ShipLoad } from 'modules/domain/deal/types'
import { FC, useState } from 'react'
import styled from 'styled-components'
import { AButton } from 'views/components/Analytics'
import { FarmerLoadActions } from './FarmerLoadActions'
import { ShipLoadActions } from './ShipLoadActions'

const AlignFlexWrapper = styled.div`
  display: flex;
  align-items: center;
`

type Props = {
  loadItem: ShipLoad | FarmerLoad
  refetch: refetchFunc
}

export const ShipLoadActionsCell: FC<Props> = ({ loadItem, refetch }) => {
  const [popoverVisible, setPopoverVisible] = useState(false)

  return (
    <AlignFlexWrapper>
      <AntPopover
        content={
          <ShipLoadActions refetch={refetch} loadItem={loadItem as ShipLoad} setPopoverVisible={setPopoverVisible} />
        }
        placement="bottomRight"
        trigger="click"
        open={popoverVisible}
        onOpenChange={() => setPopoverVisible(!popoverVisible)}
      >
        <AButton id="popover" color="secondary" background="none" Icon={Icons.IconMoreHoriz} />
      </AntPopover>
    </AlignFlexWrapper>
  )
}

export const FarmerLoadActionsCell: FC<Props> = ({ loadItem, refetch }) => {
  const [popoverVisible, setPopoverVisible] = useState(false)

  return (
    <AlignFlexWrapper>
      <AntPopover
        content={
          <FarmerLoadActions
            refetch={refetch}
            loadItem={loadItem as FarmerLoad}
            setPopoverVisible={setPopoverVisible}
          />
        }
        placement="bottomRight"
        trigger="click"
        open={popoverVisible}
        onOpenChange={() => setPopoverVisible(!popoverVisible)}
      >
        <AButton id="popover" color="secondary" background="none" Icon={Icons.IconMoreHoriz} />
      </AntPopover>
    </AlignFlexWrapper>
  )
}
